/**
 * WordPress dependencies
 */
import { __ } from "@wordpress/i18n";
import { useState, useEffect } from "@wordpress/element";
import { InspectorControls, PanelColorSettings } from "@wordpress/block-editor";
import {
    PanelBody,
    Button,
    BaseControl,
} from "@wordpress/components";
import { select } from "@wordpress/data";

export default function SupportPanel({ blockName }) {

    const block_name = blockName.substring(blockName.lastIndexOf("/") + 1);
    const blockKey = block_name.replace(/-/g, "_");

    const defaultValue = EssentialBlocksLocalize?.all_blocks_default[blockKey]

    return (
        <>
            {defaultValue && (
                <InspectorControls key="controls">
                    <div className="eb-panel-control eb-support-panel">
                        <div className="eb-block-support">
                            <img
                                src={`${EssentialBlocksLocalize?.eb_plugins_url}assets/images/eb-icon-128x128.png`}
                                alt="Essential Blocks Icon"
                            />
                            <a
                                href="javascript:void(0)"
                                // target="_blank"
                            >Need Help?</a>
                        </div>
                        <div className="eb-block-links">
                            <Button
                                href={defaultValue.demo}
                                target="_blank"
                            >
                                <img
                                    src={`${EssentialBlocksLocalize?.eb_plugins_url}assets/images/demo-icon.svg`}
                                    alt="Essential Blocks Icon"
                                />
                                Demo
                            </Button>
                            <Button
                                href={defaultValue.doc}
                                target="_blank"
                            >
                                <img
                                    src={`${EssentialBlocksLocalize?.eb_plugins_url}assets/images/doc-icon.svg`}
                                    alt="Essential Blocks Icon"
                                />
                                Doc
                            </Button>
                        </div>

                    </div>
                </InspectorControls>
            )}
        </>
    )
}